export const styles = theme => ({
    inputField: {
    }
});
